<template>
  <div id="impressum" class="sub-page">
    <b-container>
      <b-row>
        <b-col>
          <h1>
            <span>Impressum</span>
          </h1>
          <p>
            Die Gartenfee, Auf der Herrenweide 3, 63607 Wächtersbach
          </p>
          <p>
            Telefon: 06053-4795
          </p>
          <p>
            Fax: 06053-4790
          </p>
          <p>
            E-Mail: gartenfeewbach@aol.com
          </p>
          <p>
            Geschäftsführer: Reinhardt Schneider
          </p>
          <p>
            Umsatzsteuer-Identifikationsnummer: 01986700539
          </p>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
    export default {
        name: 'Impressum',
    }
</script>
